module.exports = __webpack_public_path__ + "img/examination-report-bg.8ceafe42.png";